import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import auth from './auth'
import password from './password'
import signup from './signup'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        auth,
        password,
        signup
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
})
